/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { memo } from 'react';
import Styles from '../css/EnvelopeWithBox.module.css';
import { useAuthContext } from '../contexts/AuthContext';
import { useViewingContext } from '../contexts/ViewingContext';

const EnvelopeWithBox = ({ children, blockName, onBlockClick = null, className = '', disabled = null }) => {
  const { fullAccess } = useAuthContext();
  const { isServicerView } = useViewingContext();
  const accessGranted = (disabled !== null ? !disabled : fullAccess) || !isServicerView;

  // Judith Espinal - SQC-766: typographic compact title on borrower mobile/tablet
  const sectionClassName = [!isServicerView ? Styles.envelopeAccent : '', className].filter(Boolean).join(' ');

  return (
    <div className={Styles.envelope}>
      <section className={sectionClassName}>
        {onBlockClick ? (
          <h1 title={blockName}>
            <button onClick={onBlockClick}>{blockName}</button>
          </h1>
        ) : (
          <h1 title={blockName}>
            <span>{blockName}</span>
          </h1>
        )}
        <div>
          <div>
            <fieldset disabled={!accessGranted}>
              <article>{children}</article>
            </fieldset>
          </div>
        </div>
      </section>
    </div>
  );
};

export default memo(EnvelopeWithBox);
